// extracted by mini-css-extract-plugin
export var container = "_il-1";
export var cornerButtonContainer = "_il-6";
export var disabled = "_il-2";
export var dragActive = "_il-3";
export var fileContainer = "_il-5";
export var hiddenInput = "_il-4";
export var widthContainer = "_il-0";